import { InjectionToken, Provider } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('WindowToken');

export function provideWindow(): Provider {
  return {
    provide: WINDOW,
    useFactory: () => {
      if (typeof window === 'undefined') {
        throw new Error('Window is not available in this environment.');
      }
      return window;
    },
  };
}
